"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hitTypeText = exports.checkFrontLine = exports.checkHit = exports.parseFrontLineDate = exports.DateDisplayFormat = exports.FrontLineDateFormat = exports.DefaultAppOptions = exports.AddressType = exports.asArray = exports.getGeoJSONs = exports.isHitType = exports.hitTypes = exports.HitType = void 0;
const date_fns_1 = require("date-fns");
var HitType;
(function (HitType) {
    HitType[HitType["Fougasse"] = 0] = "Fougasse";
    HitType[HitType["Artillery"] = 1] = "Artillery";
    HitType[HitType["Incendiary"] = 2] = "Incendiary";
})(HitType = exports.HitType || (exports.HitType = {}));
/**
 * All hit types as an array.
 */
exports.hitTypes = [
    HitType.Incendiary,
    HitType.Fougasse,
    HitType.Artillery,
];
function isHitType(value) {
    return typeof value === "number" && exports.hitTypes.includes(value);
}
exports.isHitType = isHitType;
function getGeoJSONs(requireContext) {
    return requireContext.keys().map((key) => {
        return requireContext(key);
    });
}
exports.getGeoJSONs = getGeoJSONs;
function asArray(position) {
    return [position.lat, position.lng];
}
exports.asArray = asArray;
var AddressType;
(function (AddressType) {
    AddressType["MODERN"] = "modern";
    AddressType["HISTORIC"] = "historic";
})(AddressType = exports.AddressType || (exports.AddressType = {}));
exports.DefaultAppOptions = {
    hit: {
        addrType: AddressType.MODERN,
        street: "",
        houseNumber: null,
        minDate: null,
        maxDate: null,
        types: [HitType.Fougasse, HitType.Incendiary, HitType.Artillery],
    },
    frontLine: {
        show: true,
        date: null,
    },
};
exports.FrontLineDateFormat = "yyyy-MM-dd";
exports.DateDisplayFormat = "dd.MM.yyyy";
/**
 * Parse front-line date.
 */
function parseFrontLineDate(date) {
    return (0, date_fns_1.parse)(date, exports.FrontLineDateFormat, new Date());
}
exports.parseFrontLineDate = parseFrontLineDate;
/**
 * Check if artillery hit satisfies filters.
 */
function checkHit(hit, filters) {
    if (filters.street && !hit.address.street.includes(filters.street)) {
        return false;
    }
    if (filters.houseNumber != null &&
        hit.address.houseNumber !== filters.houseNumber) {
        return false;
    }
    if (filters.minDate != null && hit.date < filters.minDate) {
        return false;
    }
    if (filters.maxDate != null && hit.date > filters.maxDate) {
        return false;
    }
    if (!filters.types.includes(hit.type)) {
        return false;
    }
    return true;
}
exports.checkHit = checkHit;
function checkFrontLine(frontLine, filters) {
    if (!filters.show) {
        return false;
    }
    if (filters.date != null) {
        const date = filters.date;
        return frontLine.features.every((feature) => parseFrontLineDate(feature.properties.dateStart) <= date &&
            parseFrontLineDate(feature.properties.dateEnd) >= date);
    }
    return true;
}
exports.checkFrontLine = checkFrontLine;
function hitTypeText(type) {
    switch (type) {
        case HitType.Artillery:
            return "Артиллерийский снаряд";
        case HitType.Fougasse:
            return "Фугасная бомба";
        case HitType.Incendiary:
            return "Зажигательный снаряд";
    }
}
exports.hitTypeText = hitTypeText;
